import React from "react";
import { Box, useMediaQuery, useTheme, Avatar, Typography, Chip, IconButton, Tooltip, Divider } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import Sidebar from "./Sidebar";
import WelcomeWishModal from "../common/WelcomeWishModal";
import { useAuth } from "../../context/AuthContext";

const ROLE_COLORS = {
  admin: "#FF6B35", support_team: "#4472C4", team_member: "#2E7D32",
  qa_team: "#7B1FA2", higher_authority: "#C62828",
};
const ROLE_LABELS = {
  admin: "Admin", support_team: "Support Team", team_member: "Team Member",
  qa_team: "QA Team", higher_authority: "Management",
};

function TopBar({ user, onLogout }) {
  return (
    <Box
      sx={{
        height: 60,
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: 2,
        px: 3,
        bgcolor: "#fff",
        borderBottom: "1px solid",
        borderColor: "divider",
      }}
    >
      <Box sx={{ textAlign: "right" }}>
        <Typography variant="body2" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
          {user?.name}
        </Typography>
        <Chip
          label={ROLE_LABELS[user?.role] || user?.role}
          size="small"
          sx={{
            height: 16, fontSize: "0.6rem", fontWeight: 700, mt: 0.3,
            bgcolor: `${ROLE_COLORS[user?.role]}18`, color: ROLE_COLORS[user?.role],
          }}
        />
      </Box>
      <Avatar sx={{ width: 36, height: 36, bgcolor: ROLE_COLORS[user?.role] || "#4472C4", fontSize: "0.85rem", fontWeight: 700 }}>
        {user?.name?.charAt(0).toUpperCase()}
      </Avatar>
      <Divider orientation="vertical" flexItem sx={{ my: 1 }} />
      <Tooltip title="Logout">
        <IconButton onClick={onLogout} sx={{ color: "text.secondary", '&:hover': { color: '#C62828', bgcolor: 'rgba(198,40,40,0.08)' } }}>
          <LogoutIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
}

export default function AppLayout({ children }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { user, logout } = useAuth();

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
        overflow: "hidden",
        bgcolor: "background.default",
      }}
    >
      <WelcomeWishModal />
      <Sidebar />
      <Box
        component="main"
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          maxWidth: "100%",
          minWidth: 0,
        }}
      >
        {!isMobile && <TopBar user={user} onLogout={logout} />}
        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            overflowX: "hidden",
            p: { xs: 2, sm: 3 },
            pt: isMobile ? "72px" : { xs: 2, sm: 3 }, // clear the fixed mobile AppBar
            pb: isMobile ? "72px" : { xs: 2, sm: 3 }, // clear the fixed mobile BottomNav
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
}